<template>
  <div id="app">
    <div class="header-wrapper">
      <img id="logo" src="@/assets/images/logo.png" />
      <div id="nav">
        <router-link to="/portfolio">Portfolio</router-link>
        <router-link to="/about">About</router-link>
        <SignLink></SignLink>
      </div>
    </div>
    <router-view />
  </div>
</template>
<script>
import SignLink from "@/components/SignLink.vue";
export default {
  name: "App",
  components: {
    SignLink
  },
  created() {
    document.title = process.env.VUE_APP_TITLE;
  }
};
</script>
<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px 0 0 20px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
  padding-bottom: 0px;
  display: inline-block;
}
#logo {
  width: 50px;
  vertical-align: middle;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
#nav a:last-child:after {
  content: "";
}
#nav a:hover {
  /*border-bottom: 2px solid;*/
}
#nav a:after {
  color: #ddd;
  content: "|";
  margin: 0px 15px;
  text-decoration: none;
  display: inline-block;
}
div.body-wrapper {
  height: 100px;
  margin: 0px 50px;
}
div.notes {
  text-align: left;
  padding: 10px;
}
div.notes ul {
  list-style-type: square;
  padding-left: 18px;
}

div.privacy {
  margin: auto;
  width: 75%;
  padding: 10px;
  text-align: center;
}
div.privacy h2 {
  margin-bottom: 0px;
}

/*--- slider --*/
.slider {
  height: 350px;
  position: relative;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-flow: row nowrap;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;

  border-top: 3px dashed #ddd;
  border-bottom: 3px dashed #ddd;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
}
.slider__nav {
  width: 12px;
  height: 12px;
  margin: 1.5rem 12px;
  border-radius: 50%;
  z-index: 10;
  outline: 6px solid #ccc;
  outline-offset: -6px;
  box-shadow: 0 0 0 0 #333, 0 0 0 0 rgba(51, 51, 51, 0);
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.slider__nav:checked {
  -webkit-animation: check 0.4s linear forwards;
  animation: check 0.4s linear forwards;
}
.slider__nav:checked:nth-of-type(1) ~ .slider__inner {
  left: 0%;
}
.slider__nav:checked:nth-of-type(2) ~ .slider__inner {
  left: -100%;
}
.slider__nav:checked:nth-of-type(3) ~ .slider__inner {
  left: -200%;
}
.slider__nav:checked:nth-of-type(4) ~ .slider__inner {
  left: -300%;
}
.slider__inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 400%; /* 100% * number of slides */
  height: 100%;
  -webkit-transition: left 0.4s;
  transition: left 0.4s;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-flow: row nowrap;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.slider__contents {
  height: 100%;
  padding: 0rem;
  text-align: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.slider__icon {
  font-size: 2.7rem;
  color: #2196f3;
}
.slider__caption {
  font-weight: 500;
  margin: 0.5rem 0 0rem;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
}
.slider__txt {
  color: #444;
  margin: 0.5rem 0 3rem;
  max-width: 300px;
  min-height: 2.5em;
  font-style: italic;
}
.slider__description {
  -webkit-flex-flow: column nowrap;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
}
.slider__image {
  flex-grow: 0;
  flex-shrink: 0;
  margin: 0 0.5rem;
  height: 270px;
}
.slider__note {
  color: #444;
  margin: 0.5rem 0 3rem;
  width: 300px;
  height: 270px;
  list-style-type: square;
  resize: none;
  font-size: 1em;

  border: none;
  overflow: auto;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

@-webkit-keyframes check {
  50% {
    outline-color: #333;
    box-shadow: 0 0 0 12px #333, 0 0 0 36px rgba(51, 51, 51, 0.2);
  }
  100% {
    outline-color: #333;
    box-shadow: 0 0 0 0 #333, 0 0 0 0 rgba(51, 51, 51, 0);
  }
}

@keyframes check {
  50% {
    outline-color: #333;
    box-shadow: 0 0 0 12px #333, 0 0 0 36px rgba(51, 51, 51, 0.2);
  }
  100% {
    outline-color: #333;
    box-shadow: 0 0 0 0 #333, 0 0 0 0 rgba(51, 51, 51, 0);
  }
}

@media screen and (min-width: 400px) {
  .slider__contents {
    width: auto;
  }
  .slider__image {
    display: none;
  }
}
@media screen and (min-width: 600px) {
  .slider__contents {
    width: 500px;
  }
  .slider__image {
    display: flex;
    height: 220px;
  }
}
@media screen and (min-width: 900px) {
  .slider__contents {
    width: auto;
  }
  .slider__image {
    display: flex;
    height: 250px;
  }
}
@media screen and (min-width: 1100px) {
  .slider__contents {
    width: auto;
  }
  .slider__image {
    display: flex;
    height: 250px;
  }
}

/*--- end slider --*/
</style>
